import { twJoin, twMerge } from 'tailwind-merge';

import { cs } from '@/_shared';

import { Skeleton } from '../progress';

export function TableSkeleton({
  numberOfColumns,
  maxRows = 15,
  containerClassName,
  equalWidthCols = false,
}: {
  numberOfColumns: number;
  maxRows?: number;
  containerClassName?: string;
  equalWidthCols?: boolean;
}) {
  const rows = Array.from({ length: maxRows }, (_, index) => index);
  const restCols = equalWidthCols ? numberOfColumns : numberOfColumns - 2;

  return (
    <div className={twMerge('border-c-border border', 'rounded-xl', cs('rounded-4xl'), containerClassName)}>
      {rows.map((r, i) => (
        <div
          className={twJoin(
            'border-c-border flex gap-x-2 border-b px-4 last-of-type:border-b-0',
            i === 0 ? 'py-3.5' : 'py-2'
          )}
          key={r}
        >
          {!equalWidthCols && (
            <>
              <Skeleton className="size-7 shrink-0" />
              <Skeleton className="h-7 flex-1" />
            </>
          )}
          {Array.from({ length: restCols }, (_, i) => i + 1).map((j) => (
            <Skeleton className={restCols === 1 ? 'h-7 w-24 shrink-0' : 'h-7 flex-1'} key={j} />
          ))}
        </div>
      ))}
    </div>
  );
}
